<app-type-adresseTEMPOST [disabled]="disabled" [uid]="getUid()" [parentForm]="parentForm"
     [libelle]="facturation?.libelle" [typeEntite]="facturation?.typeEntite"
     [noServiceExecutant]="facturation?.noServiceExecutant" [numBonCommande]="facturation?.numBonCommande"
     [identifiantAdressage]="facturation?.identifiantAdressage"
     (typeEntiteChange)="onTypeEntiteChange($event)"></app-type-adresseTEMPOST>

<app-type-oui-non [disabled]="disabled" *ngIf="false" [uid]="getUid()" [parentForm]="parentForm"
     [userChorus]="facturation?.userChorus"></app-type-oui-non>
